import { registerBlockType } from "@wordpress/blocks"
import Edit from "./edit"

registerBlockType("puroclean/emergency-banner", {
  edit: Edit,
  save: () => null // Server-side rendered block
}) 